/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const timesheetDocumentChangeDtoSchema = z.object({
  id: z.coerce.number().int().nullable().nullish(),
  fileName: z.coerce.string().nullable().nullish(),
  description: z.coerce.string().nullable().nullish(),
  updateDescription: z.boolean().optional(),
  contentType: z.coerce.string().nullable().nullish(),
  fileExtension: z.coerce.string().nullable().nullish(),
  fileSizeBytes: z.coerce.number().int().nullable().nullish(),
  contentBase64: z.coerce.string().nullable().nullish(),
  deleteScope: z.coerce.string().nullable().nullish(),
});
